import store from '../store';
export default function notify(message, status) {
    store.dispatch(
        'notification/show',
        {
            active: true,
            color: status,
            text: message
        },
        { root: true }
    );
}
